import {
	Card,
	InputAdornment, makeStyles,
	SvgIcon, Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
	TextField,
	Tooltip, Typography
} from '@material-ui/core';
import TableContainer from "@material-ui/core/TableContainer";
import Fuse from 'fuse.js';
import React, { useEffect } from 'react';
import { Search as SearchIcon } from 'react-feather';
import ActionButton from './ActionButtons';
import EnableButton from './EnableButton';



const withTooltip = (text, width) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			width: `${width}px`
		}}>
			{text}
		</div>
	</Tooltip >
)

const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	},
	box: {
		width: '100%'
	},
	alignLeft: {
		float: 'left',
		width: '50%'
	},
	alignRight: {
		float: 'right',
		width: '50%'
	}
});

const options = {
	includeScore: false,
	keys: [
		'vehicle.color',
		'vehicle.company',
		'vehicle.name',
		'vehicle.model',
		'vehicle.registration_number',
		'vehicle.registration_state',
		'vehicle.type',
		'vehicle.year',
	]
}

const Results = ({ selectedGeofence, columns }) => {
	const classes = useStyles();
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);
	const [data, setData] = React.useState(selectedGeofence);
	let rows = { ...data };
	useEffect(() => {
		setData(selectedGeofence);
		rows = { ...data };
	}, [selectedGeofence]);// eslint-disable-line

	const [searchField, setSearchField] = React.useState('');

	const handleChangePage = (even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};
	if (searchField) {
		const fuse = new Fuse(rows.vehicles, options);
		rows.vehicles = fuse.search(searchField).map(item => {
			return item.item;
		})
	} else if (!searchField.localeCompare('')) {
		rows = { ...data };
	}

	return (
		<Card
			className={classes.root}
		>
			<TableContainer className={classes.container}>
				<Table stickyHeader aria-label="sticky table" size={'small'}>
					<TableHead>
						<TableRow>
							<TableCell colSpan={columns.length} align={'left'}>
								<div className={classes.box}>
									<div className={classes.alignLeft}>
										<Typography variant="h4">
											{selectedGeofence.name}
										</Typography>
									</div>
									<div className={classes.alignRight}>
										<TextField
											fullWidth
											size={'small'}
											InputProps={{
												startAdornment: (
													<InputAdornment position="start">
														<SvgIcon
															fontSize="small"
															color="action"
														>
															<SearchIcon />
														</SvgIcon>
													</InputAdornment>
												)
											}}
											onChange={e => setSearchField(e.target.value)}
											placeholder="Search Vehicle"
											variant="outlined"
										/>

									</div>
								</div>
							</TableCell>
						</TableRow>
						<TableRow>
							{columns.map((column) => (
								<TableCell
									key={column.field}
									align={column.align}
									style={{ minWidth: column.width }}
								>
									{column.headerName}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{
							rows && rows.vehicles && rows.vehicles.length > 0 ?
								rows.vehicles
									.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
									.map((row, index) => {
										// if(row.removed) return;
										return (
											<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>
												{columns.map((column) => {
													if (column.field === 'enabled') {
														return (
															<TableCell key={column.field} align={column.align}>
																<EnableButton row={rows} index={index} />
															</TableCell>
														)
													}
													if (column.field === 'registration') {
														return (
															<>
																<TableCell key={column.field} align={column.align}>
																	{withTooltip(`${row.vehicle.registration_number} - ${row.vehicle.registration_state}`, column.width)}
																</TableCell>
															</>
														)
													}
													if (column.field === 'actions') {
														return (
															<>
																<TableCell key={column.field} align={column.align}>
																	<ActionButton row={rows} index={index} />
																</TableCell>
															</>
														)
													}
													const value = row.vehicle[column.field];
													return (
														<TableCell key={column.field} align={column.align}>
															{column.format && typeof value === "number"
																? column.format(value)
																: withTooltip(value, column.width)}
														</TableCell>
													);
												})}
											</TableRow>
										);
									})
								: <TableRow>
									<TableCell colSpan={columns.length} align={'center'}>
										No Vehicles Assigned
									</TableCell>
								</TableRow>
						}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePagination
				rowsPerPageOptions={[10, 25, 100]}
				component="div"
				count={rows ? rows.vehicles.length : 0}
				rowsPerPage={rowsPerPage}
				page={page}
				onChangePage={handleChangePage}
				onChangeRowsPerPage={handleChangeRowsPerPage}
			/>
			{/* </Paper> */}

		</Card>
	);
};


export default Results;
